import { useQuery } from "@tanstack/react-query";

import { getPostModuleAssessmentQuestionApiCall } from "./utils.api";

import { postModuleAssessmentKeys } from "../../../../redux/services/postModuleAssessment";

export const useGetPostModuleAssessmentQuestion = (payload) =>{
    const {courseId, moduleId  , languageid}= payload;

    return useQuery({
        queryKey: postModuleAssessmentKeys.getPostModuleAssessmentKeys({courseId, moduleId  , languageid}),
        queryFn: () => getPostModuleAssessmentQuestionApiCall({courseId, moduleId  , languageid}),
    });
}